import StatusHandler from 'app/shared-components/StatusHandler'
import requestConfig from 'app/requests/Company.requests'
import SkyMindSync from 'app/shared-components/SkyMindSync'

import useGetCompany from '../hooks/useGetCompany'

const SkyMindSyncContainer = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetCompany(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <SkyMindSync
                requestParams={requestConfig.skyMindSyncUpdate({
                    id,
                })}
                skyMindId={data?.skyMindId}
                invalidate={invalidate}
            />
        </StatusHandler>
    )
}

export default SkyMindSyncContainer
